module.exports = __webpack_public_path__ + "img/consultation_mini.af930b22.png";